import { useAxios } from "@hooks";
import { useMutation } from "@tanstack/react-query";

/**
 * Refreshes the current assessor's live grading presence (heartbeat).
 */
export const useGradingHeartbeat = () => {
  const axios = useAxios();

  return useMutation<void, Error, string>({
    mutationFn: async (examInstanceId: string) => {
      await axios.post(`/api/grading/examinstances/${examInstanceId}/heartbeat`);
    },
  });
};

export default useGradingHeartbeat;
